import { Box, Divider, styled } from '@mui/material';

export const BoxContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
});

export const RowNoData = styled('div')({
  fontSize: 20,
  margin: 'auto',
});

export const AppDivider = styled(Divider)({
  margin: '16px 0',
});
